import {
  SERVICEORDERS_REQUEST_FAIL,
  SERVICEORDERS_REQUEST_SUCCESS,
  SERVICEORDERS_REQUEST_STOP,
  SERVICEORDERS_CONTRACTOR_REQUEST_SUCCESS,
  SERVICEORDERS_CONTRACTOR_REQUEST_FAIL
} from "../action.types";
import initialState from "../initial.state";

export default function(state = initialState.serviceOrders, action) {
  switch (action.type) {
    case SERVICEORDERS_REQUEST_SUCCESS:
      return { ...action.payload };
    case SERVICEORDERS_REQUEST_FAIL:
      return state;
    case SERVICEORDERS_REQUEST_STOP:
      return initialState.serviceOrders;
    case SERVICEORDERS_CONTRACTOR_REQUEST_SUCCESS:
      return { ...action.payload };
    case SERVICEORDERS_CONTRACTOR_REQUEST_FAIL:
      return state;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/serviceOrder/serviceOrders.reducer.js